import React, { useState } from 'react';
import './FoldCard.css';

/* Card DÉPLIABLE à icône — reprise du stepper du plan de liquidité, dont elle
   garde le geste (en-tête cliquable, chevron, corps qui s'ouvre) mais pas la
   pastille numérotée : ici les cards ne forment pas une séquence à suivre, ce
   sont deux sujets côte à côte. L'icône dit lequel.

   `defaultOpen` — une card qu'on ouvre à chaque visite n'a pas besoin d'être
   dépliable ; ne la fermer par défaut que si son contenu est rarement touché. */
export default function FoldCard({ icon, title, subtitle, defaultOpen = true, actions = null, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={`fcard${open ? ' is-open' : ''}`}>
      <div className="fcard__head">
        <button type="button" className="fcard__toggle" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
          {icon && <span className="fcard__icon" aria-hidden="true">{icon}</span>}
          <span className="fcard__titles">
            <span className="fcard__title">{title}</span>
            {subtitle && <span className="fcard__sub">{subtitle}</span>}
          </span>
          <span className="fcard__chev" aria-hidden="true">{open ? '▾' : '▸'}</span>
        </button>
        {actions && <span className="fcard__actions">{actions}</span>}
      </div>
      {open && <div className="fcard__body">{children}</div>}
    </section>
  );
}
